import { Permission } from '../../../backend/src/auth/permissions/permission';
import { useUserContext } from '../Contexts/User';

export function useHasPermission() {
  const { user } = useUserContext();

  const hasPermission = (permission: Permission) => {
    return user?.role.permissions.includes(permission) ?? false;
  };

  return { hasPermission };
}
